import React, { useEffect } from 'react';
import usePepe from '../../../../contexts/Pepe';
import Loader from '../../../general/loader';
import Web3 from 'web3';
import { AbstractProvider } from 'web3-core';
import fetcher, { Fetcher } from '../../../../utils/fetcher';
import localStorage from '../../../../utils/localStorage';

interface Props {
  onComplete: () => any;
}

type ConnectResult = {
  web3: Web3;
  publicAddress: string;
};

const LoginSecondStage = ({ onComplete }: Props) => {
  const { activate } = usePepe();

  useEffect(() => {
    initMM()
      .then((result) => {
        const { publicAddress: address, web3 } = result;
        getNonce(address, web3);
      })
      .catch(() => {
        activate();
      });
  }, []);

  const initMM = async (): Promise<ConnectResult> => {
    return new Promise(async (resolve, reject) => {
      try {
        if (!window.ethereum) {
          return reject();
        }
        const web3 = await getWeb3();
        if (!web3) {
          return reject();
        }
        await web3.eth.getAccounts();
        const coinbase = await web3.eth.getCoinbase();
        if (!coinbase) {
          return reject();
        }
        resolve({ web3, publicAddress: coinbase.toLowerCase() });
      } catch (err) {
        reject();
      }
    });
  };

  const getWeb3 = async (): Promise<Web3 | undefined> => {
    try {
      await window.ethereum.request({
        method: 'eth_requestAccounts'
      });
      return new Web3(window.ethereum as AbstractProvider);
    } catch (err) {
      return undefined;
    }
  };

  const getNonce = (address: string, web3: Web3) => {
    fetcher.login
      .getNonce(address)
      .then((result) => {
        signMessage(result.nonce, address, web3);
      })
      .catch(() => {
        activate();
      });
  };

  const signMessage = (nonce: string, address: string, web3: Web3) => {
    web3.eth.personal
      .sign(`Wanna some ${nonce}?`, address, '')
      .then((signature) => {
        mmLogin(signature, address);
      })
      .catch(() => {
        activate();
      });
  };

  const mmLogin = (signature: string, address: string) => {
    fetcher.login
      .mmLogin(address, signature)
      .then((response) => {
        Fetcher.setMMTokenHeader(response.token);
        localStorage.setMMToken(response.token);
        onComplete();
      })
      .catch(() => {
        activate();
      });
  };

  return <Loader size='Min(130px, 30vw)' color='primary' />;
};

export default LoginSecondStage;
